export enum GelatoPublisherEventName {
  CLICKED = 'Gelato Publisher Clicked',
  UPLOAD_DESIGN_CLICKED = 'Gelato Publisher Upload Design Clicked',
  PRODUCTS_SELECTED = 'Gelato Publisher Products Selected',
  CREATE_HEADER_BUTTON_CLICKED = 'Create Header Button Clicked',
  MOCKUP_SELECTED = 'Gelato Publisher Mockup Selected',
  DESCRIPTION_SELECTED = 'Gelato Publisher Description Selected',
  PRICES_SELECTED = 'Gelato Publisher Prices Selected',
  PRODUCT_REVIEWED = 'Gelato Publisher Product Reviewed',
  PRODUCT_PUBLISHED_SUCCESSFUL = 'Gelato Publisher Product Published Successful',
  PRODUCT_PUBLISHED_FAILED = 'Gelato Publisher Product Published Failed',
  EDITING_STARTED = 'Gelato Publisher Editing Started',
  EDITING_COMPLETED = 'Gelato Publisher Editing Completed',
  VARIANT_LIMIT_EXCEEDED = 'Gelato Publisher Variant Limit Exceeded',
  GELATO_PUBLISHER_VARIATIONS_SELECTED = 'Gelato Publisher Variations Selected',
  GELATO_PUBLISHER_EDIT_OPTION_CLICKED = 'Gelato Publisher Edit Option Clicked',
  GELATO_PUBLISHER_OPTION_EDITING_STARTED = 'Gelato Publisher Option Editing Started',
  GELATO_PUBLISHER_OPTION_EDITING_COMPLETE = 'Gelato Publisher Option Editing Complete',
  GELATO_PUBLISHER_OPTION_TRANSLATED = 'Gelato Publisher Option Translated ',
  GELATO_PUBLISHER_UPLOADED = 'Gelato Publisher Uploaded',
}
